import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PtlWindowLocationService } from '@ptl/global-components';
import { REDUCER_TYPES } from '@ptl/state';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { FILE_RESPONSE } from './interfaces/file-response.enum';
import { MassUploadFile } from './interfaces/mass-upload-file.interface';
import { MassUploadService } from './services/mass-upload.service';
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from "@ptl/account-management";
import moment from 'moment';
@Component({
    selector: 'app-mass-upload',
    templateUrl: './mass-upload.component.html',
    styleUrls: ['./mass-upload.component.scss'],
    standalone: false
})
export class MassUploadComponent implements OnInit {


  @Input() cardOneLabel: string;
  @Input() cardOneSubtitle: string;
  @Input() cardOneAlert: string;
  @Input() showCardOneAlert: string;
  @Input() cardOneButtonLabel: string;
  @Input() showCardOneButtonLabel: string;
  @Input() cardOneButtonLabelTwo: string;
  @Input() showCardOneButtonLabelTwo: string;
  @Input() cardTwoLabel: string;
  @Input() cardTwoSubtitle: string;
  @Input() cardThreeLabel: string;
  @Input() cardThreeSubtitle: string;
  @Input() cardThreeButtonLabel: string;
  @Input() cardFourLabel: string;
  @Input() cardFourSubtitle: string;
  @Input() cardFiveLabel: string;
  @Input() cardFiveSubtitle: string;
  @Input() brokerTemplatePath: string;
  @Input() brokerTemplatePathTwo: string;
  @Input() showCardOne: string;
  @Input() showCardTwo: string;
  @Input() showCardThree: string;
  @Input() showCardFour: string;
  @Input() showCardFive: string;
  @Input() downloadErrorLogPrefix: string;
  @Input() noEntitlementsMessage: string;
  @Input() submissionLogsUrl: string;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;

  displayCardOne: boolean;
  displayCardTwo: boolean;
  displayCardThree: boolean;
  displayCardFour: boolean;
  displayCardFive: boolean;

  displayCardOneAlert: boolean;
  displayCardOneButtonOne: boolean;
  displayCardOneButtonTwo: boolean;

  loginId: string;
  displayedColumns: string[] = [
    'filename',
    'dateTime',
    'message',
    'fileId',
    'logs',
    'icon'
  ];

  hasEntitlement = false;

  dataSource: MatTableDataSource<MassUploadFile>;

  fileNameFilter = new FormControl('');;
  dateFilter = new FormControl('');
  statusFilter = new FormControl('');
  fileIdFilter = new FormControl('');

  filterValues = {
    filename: '',
    dateTime: '',
    message: '',
    fileId: ''
  }

  showStatusBox: boolean;
  statusText: string;
  showSpinner: boolean;
  showSubmissionLogIcon: boolean;
  successBanner: boolean;
  showTooltipOnTruncatedMessage: boolean;

  constructor(
    private massUploadService: MassUploadService,
    private reducerUtilityService: ReducerUtilityService,
    private httpClient: HTTPWrapperContext,
    private windowLocationService: PtlWindowLocationService,
    private entitlementsHelperService: EntitlementsHelperService
  ) {}

  async ngOnInit() {
    const loginData: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    const hasMassEnrollEntitlement = await this.entitlementsHelperService.entitlementValueForSelectedAgencyByNameAndLob(ENTITLEMENTS.MASS_UPLOAD, LINE_OF_BUSINESS_ENUM.INDIVIDUAL, loginData?.userInfo?.role as USER_ROLE);

    if (hasMassEnrollEntitlement) {
      this.hasEntitlement = true;
    } else {
      this.hasEntitlement = false;
    }

    const USER_INFO_STATE_NAME = `${REDUCER_TYPES.APPLICATION_STATE}.${LOGIN_INFO_REDUCER_NAME}`;
    const userInfoState: UserInfoStateStructure = this.reducerUtilityService.getGlobalStateItem(USER_INFO_STATE_NAME);
    this.loginId = userInfoState.userId;

    if (this.showCardOne === "true") {
      this.displayCardOne = true;
    }
    if (this.showCardTwo === "true") {
      this.displayCardTwo = true;
    }
    if (this.showCardThree === "true") {
      this.displayCardThree = true;
    }
    if (this.showCardFour === "true") {
      this.displayCardFour = true;
    }
    if (this.showCardFive === "true") {
      this.displayCardFive = true;
    }
    if (this.showCardOneAlert === "true") {
      this.displayCardOneAlert = true;
    }
    if (this.showCardOneButtonLabel === "true") {
      this.displayCardOneButtonOne = true;
    }
    if (this.showCardOneButtonLabelTwo === "true") {
      this.displayCardOneButtonTwo = true;
    }

    await this.getMassEnrollmentStatus();
    this.getFilterSubscriptions();
  }

  async getMassEnrollmentStatus(): Promise<void> {
    const response = await this.massUploadService.retrieveFilesByLoginId(this.loginId);
    const responsePayload: MassUploadFile[] = response['payload'];


    this.transformResponseToDataSource(responsePayload);
  }

  transformResponseToDataSource(data: MassUploadFile[]) {
    this.dataSource = new MatTableDataSource<MassUploadFile>(data['files']);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = this.createFilter();
    this.dataSource.data = data['files'].map(item => 
      ({  ...item, 
      dateTime: moment(item.dateTime)}));
      this.dataSource.sort = this.sort;
      this.sort.active = 'dateTime';
      this.sort.direction = 'desc';
      this.sort.sortChange.emit({  active: 'dateTime',  direction: 'desc'});
      this.dataSource.sortData(this.dataSource.data, this.sort);
 
      this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'dateTime':
          console.log(item, item.dateTime);
          return moment(item.dateTime);
        default:
          return item[property];
      }
  
      };
    }

  downloadBrokerTemplate() {
    window.open(this.brokerTemplatePath, '_blank');
  }

  downloadBrokerTemplate2() { // This method will be removed after SEP ENDS
    window.open(this.brokerTemplatePathTwo, '_blank');
  }

  async handleFileInput(files: FileList): Promise<void> {
    this.showSpinner = true;

    try {
      let file = files.item(0);
      const response = await this.massUploadService.uploadFile(file, this.loginId);
      this.displayStatusMessage(response.payload.message);
      if (response.payload.message.toLowerCase().includes(FILE_RESPONSE.VALIDATED)) {
        this.successBanner = true;
      } else {
        this.successBanner = false;
      }
      await this.getMassEnrollmentStatus();
      this.showSpinner = false;
    } catch (error) {
      this.showSpinner = false;
      console.error('Error: ', error);
      throw error;
    }
  }

  uploadSuccess(message: string) {

    if (message.toLowerCase().includes(FILE_RESPONSE.VALIDATED)) {
      this.showSubmissionLogIcon = true;
      return true;
    } else {
      this.showSubmissionLogIcon = false;
      return false;
    }
  }

  displayStatusMessage(responseMessage: string) {
    this.showStatusBox = true;
    this.statusText = responseMessage;
  }

  getFilterSubscriptions() {
    this.fileNameFilter.valueChanges.subscribe(
      filename => {
        this.filterValues.filename = filename.toLowerCase();
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.dateFilter.valueChanges.subscribe(
      dateTime => {
        this.filterValues.dateTime = dateTime.toString();
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
    this.statusFilter.valueChanges.subscribe(
      message => {
        this.filterValues.message = message.toLowerCase();
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
    this.fileIdFilter.valueChanges.subscribe(
      fileId => {
        this.filterValues.fileId = fileId.toLowerCase();
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
  }

  createFilter(): (data: MassUploadFile, filter: string) => boolean {
    let filterFunction = function(data: MassUploadFile, filter: string): boolean {
      let searchStrings = JSON.parse(filter);
      const dataDate = moment(data.dateTime);    
      return data.filename.toLowerCase().indexOf(searchStrings.filename) !== -1
      && dataDate.format('MM/DD/YYYY HH:mm:ss').toString().indexOf(searchStrings.dateTime) !== -1
      && data.message.toLowerCase().indexOf(searchStrings.message) !== -1
      && data.fileId.toLowerCase().indexOf(searchStrings.fileId) !== -1
    };
    return filterFunction;
  }

  downloadFileFromFileId(fileId: string, type: string) {

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
        url: '/sxesvc/api/v3/bulk-enrollment/download' + '?fileId=' + fileId + '&type=' + type,
        strategyConfigs: { forceModernUrl: true }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }


  getApplicationsFromSubmissionLog(fileId: string) {
    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
        url: '/sxesvc/api/v3/bulk-enrollment/submittedApps' + '?fileId=' + fileId,
        strategyConfigs: { forceModernUrl: true }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }

  navigateToSubmittedAppsPage(fileId: string) {
    const submissionLogsPageUrl = this.submissionLogsUrl + '?fileId=' + fileId;
    this.windowLocationService.goToUrl(submissionLogsPageUrl);
  }

  async makeRequest(fileId: string) {
    const urlSuffix = "&type=ERROR";
    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      contentType: 'application/octet-stream',
      accept: 'application/octet-stream',
      responseType: 'blob',
      url: '/sxesvc/api/v3/bulk-enrollment/download?fileId=' + fileId + urlSuffix
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }

  async downloadErrorLogByFileId(fileId: string) {
    let response = await this.makeRequest(fileId);
    const fileNamePrefix = "ERROR_LOG_UTN_" + fileId;
    this.saveByteArray(fileNamePrefix, response);
  }

  saveByteArray(name: string, byte) {
    let blob = new Blob([byte], {type: "application/xlsx"});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    let fileName = name + ".xlsx";
    link.download = fileName;
    link.click();
  }

  getTruncatedFileMessage(message: string) {
    if (message.length > 50) {
      message = message.substring(0, 50) + "...";
      this.showTooltipOnTruncatedMessage = true;
      return message;
    } else {
      this.showTooltipOnTruncatedMessage = false;
      return message;
    }
  }

}

